/**
 * 项目数据模拟
 * 后期将从后端接口获取
 */

export const projectsData = [
  {
    id: 1,
    image: '/image/项目一.jpg',
    title: {
      zh: '香港博士生“创生基金-育儿津贴”（试点）',
      zh_TW: '香港博士生“創生基金-育兒津貼”（試點）',
      en: 'Hong Kong PhD Students " Genovation Foundation - Childcare Allowance" (Pilot Program)'
    },
    category: {
      zh: '推展教育',
      zh_TW: '推展教育',
      en: 'Promote Education'
    },
    categoryVariant: 'secondary',
    projectNumber: 634,
    startDate: '2026-1-1',
    status: 'in-progress',
    description: {
      zh: `**简介：**   
      针对香港高校全日制在读博士生推出的专项育儿津贴计划。博士生是科研创新的后备力量，却常因科研压力与有限收入推迟生育计划。本计划旨在为其在关键期提供支持。 

**资助额度：**  
每人5万港元育儿津贴。

**申请条件：**     
子女于2026年1月1日（含）后出生，父母一方为香港全日制在读博士生。`,
      zh_TW: `**簡介：**   
      針對香港高校全日制在讀博士生推出的專項育兒津貼計畫。博士生是科研創新的後備力量，卻常因科研壓力與有限收入推遲生育計畫。本計畫旨在為其在關鍵期提供支援。

**資助額度：**   
每人5萬港元育兒津貼。

**申請條件：**   
子女於2026年1月1日（含）後出生，父母一方為香港全日制在讀博士生。`,
      en: `**Introduction:**   
      A special childcare allowance program launched for full-time PhD students at Hong Kong universities. PhD students are the reserve force for scientific research and innovation but often delay their family planning due to research pressure and limited income. This program aims to provide support during this critical period.

**Funding Amount:**   
HKD 50,000 childcare allowance per person.

**Eligibility Criteria:**   
The child must be born on or after January 1, 2026, and one parent must be a full-time PhD student in Hong Kong.`
    }
  },
  {
    id: 2,
    image: '/image/项目2艺术.jpg',
    title: {
      zh: '“创生基金”文化艺术创意项目征集',
      zh_TW: '“創生基金”文化藝術創意項目徵集',
      en: '" Genovation Foundation " Cultural and Artistic Creative Project Call for Submissions'
    },
    category: {
      zh: '促进生育',
      zh_TW: '促進生育',
      en: 'Promote Childbirth'
    },
    categoryVariant: 'primary',
    projectNumber: 634,
    startDate: '2025-11',
    status: 'in-progress',
    description: {
      zh: `**简介：**   
      营造积极的社会生育文化，"创生基金"特设立专项基金，面向全球征集优秀的文化艺术创意项目，旨在激励生育意愿，传递家庭价值。

**征集主题：**  
激发生育意愿，倡导生育友好，共建温暖社会。

**征集内容（不限形式）：**  
我们鼓励一切围绕主题的创意表达，鼓励创新与跨界融合。包括但不限于：  
类别1：创意项目策划，如大型文化IP策划、节演活动策划、文旅主题策划等。  
类别2：作品创作，如短视频、纪录片、摄影、绘画、雕塑、音乐、绘本、小说诗歌等。  
类别3：互动体验，如社区活动、沉浸式体验等。

**资助方式：**  
年度评选，根据项目创意、规模与影响力，单项提供至高100万港元的资金支持。

**申报主体：**  
个人、机构均可申报。

**核心要求：**  
- 主题契合：作品需紧扣"激励生育"核心，传递正向价值。
- 原创性：必须为原创作品，无任何知识产权纠纷。
- 可行性：方案需具备可执行性，并能在约定周期内完成。

**申请方式：**  
请将申请计划书发送到创生基金官方电邮地址: <info@genovationfoundation.org>。

**_本征集方案的最终解释权归"创生基金"管理委员会所有。_**
`,
      zh_TW: `**簡介：**   
      營造積極的社會生育文化，"創生基金"特設立專項基金，面向全球徵集優秀的文化藝術創意項目，旨在激勵生育意願，傳遞家庭價值。

**徵集主題：**  
激發生育意願，宣導生育友好，共建溫暖社會。

**徵集內容（不限形式）：**  
我們鼓勵一切圍繞主題的創意表達，鼓勵創新與跨界融合。包括但不限於：  
類別1：創意項目策劃，如大型文化IP策劃、節演活動策劃、文旅主題策劃等。  
類別2：作品創作，如短視頻、紀錄片、攝影、繪畫、雕塑、音樂、繪本、小說詩歌等。  
類別3：互動體驗，如社區活動、沉浸式體驗等。

**資助方式：**  
年度評選，根據項目創意、規模與影響力，單項提供至高100萬港元的資金支持。

**申報主體：**  
個人、機構均可申報。

**核心要求：**  
- 主題契合：作品需緊扣"激勵生育"核心，傳遞正向價值。
- 原創性：必須為原創作品，無任何知識產權糾紛。
- 可行性：方案需具備可執行性，並能在約定時間內完成。

**申請方式：**  
請將申請計劃書發送到創生基金官方電郵地址: <info@genovationfoundation.org>。

**_本徵集方案的最終解釋權歸"創生基金"管理委員會所有。_**`,
      en: `**Introduction:**   
      To foster a positive culture around childbirth and family life, the Genovation Foundation has launched a dedicated fund to invite outstanding cultural and artistic projects from around the world. The goal is to inspire people to have children and to promote family values.

**Themes for Submission:**  
- Inspire interest and confidence in having children
- Promote a supportive, child- and family‑friendly environment
- Help build a warm, caring society

**Content for Submission (no restrictions on form):**  
We encourage all creative expressions around the theme, promoting innovation and cross-disciplinary integration. This includes, but is not limited to:  
Category 1: Creative Project Planning, such as large-scale cultural IP planning, festival and event planning, cultural tourism theme planning, etc.  
Category 2: Creative Works, such as short videos, documentaries, photography, painting, sculpture, music, picture books, novels, poetry, etc.  
Category 3: Interactive Experiences, such as community activities and immersive experiences.

**Funding Method:**  
Annual selection, providing up to HKD 1 million in funding support per project based on creativity, scale, and impact.

**Eligibility for Application:**  
Both individuals and organizations can apply.

**Core Requirements:**  
- Theme Alignment: Works must closely adhere to the core theme of "encouraging childbirth" and convey positive values.
- Originality: Must be original works with no intellectual property disputes.
- Feasibility: The proposal must be executable and completed within the agreed timeframe.

**Application Method:**  
Please send your application proposal to the Genovation Foundation's official email address:[info@genovationfoundation.org](mailto:info@genovationfoundation.org).

**_The final interpretation of this call for submissions rests with the Genovation Foundation Management Committee._**`
    }
  },
  {
    id: 3,
    image: '/image/项目3国际.jpg',
    title: {
      zh: '全球生育危机论坛',
      zh_TW: '全球生育危機論壇',
      en: 'Global Fertility Crisis Forum'
    },
    category: {
      zh: '促进生育',
      zh_TW: '促進生育',
      en: 'Promote Childbirth'
    },
    categoryVariant: 'primary',
    projectNumber: 634,
    startDate: '2026-1-1',
    status: 'in-progress',
    description: {
      zh: `**简介：**  
      与多国知名人口经济学家、全球顶尖学府学者联合举办的国际性学术论坛。旨在汇集全球智慧，深入探讨低生育率的经济影响、政策实践、女性发展平衡等关键议题。

**首届论坛：**   
将于2026年1月在香港举办，并计划常态化举行，打造长期稳定的国际交流平台。

[点击进入论坛](https://globalfertilitycrisis.org)`,
      zh_TW: `**簡介：**   
      與多國知名人口經濟學家、全球頂尖學府學者聯合舉辦的國際性學術論壇。旨在匯集全球智慧，深入探討低生育率的經濟影響、政策實踐、女性發展平衡等關鍵議題。

**首屆論壇：**   
將於2026年1月在香港舉辦，並計畫恆常舉行，打造長期穩定的國際交流平台。

[點擊進入論壇](https://globalfertilitycrisis.org)`,
      en: `**Introduction:**   
      An international academic forum co-hosted with renowned population economists and scholars from top global universities. It aims to gather global insights and delve into key issues such as the economic impact of low fertility rates, policy practices, and the balance of women's development.

**Inaugural Forum:**   
Scheduled to be held in January 2026 in Hong Kong, with plans to establish it as a regular event, creating a long-term and stable platform for international exchange.

[Click to enter the forum](https://globalfertilitycrisis.org)`
    }
  }
];

/**
 * 根据状态筛选项目
 * @param {string} status - 'all' | 'pending' | 'completed' | 'in-progress'
 * @returns {Array} 筛选后的项目列表
 */
export const getProjectsByStatus = (status) => {
  if (status === 'all') {
    return projectsData;
  }
  return projectsData.filter(project => project.status === status);
};

/**
 * 根据分类筛选项目
 * @param {string} category - '促进生育' | '推展教育' | '纾解贫困'
 * @param {string} lang - 'zh' | 'zh_TW' | 'en'
 * @returns {Array} 筛选后的项目列表
 */
export const getProjectsByCategory = (category, lang = 'zh') => {
  return projectsData.filter(project => project.category[lang] === category);
};

/**
 * 获取项目详情
 * @param {number} id - 项目ID
 * @returns {Object|null} 项目详情
 */
export const getProjectById = (id) => {
  return projectsData.find(project => project.id === id) || null;
};

